import { UserRole } from '@vgrubs/components';

/**
 * Where a person's detail screen lives.
 *
 * Sales roles have their own page; everyone else shares one. Mirrors the branch
 * in `UsersAndAccess`, which is the list these links land next to - getting it
 * wrong sends you to a screen that renders nothing.
 */
export const userDetailsPath = (
  userId: number | string,
  role?: UserRole | string | null
) =>
  role === UserRole.salesAgent || role === UserRole.salesManager
    ? `/users/agent/${userId}`
    : `/users/${userId}`;

/**
 * Opened in a new tab rather than navigated to.
 *
 * Both call sites are inside a conversation the reader is in the middle of -
 * navigating away would close the thread, and coming back re-fetches it and
 * loses their place in the history they had scrolled through.
 */
export const openUserDetails = (
  userId: number | string,
  role?: UserRole | string | null
) => window.open(userDetailsPath(userId, role), '_blank');
